import useRetrieveFundingSessionQuery from 'src/fund/api/useRetrieveFundingSessionQuery';
import type {RetrieveFundingSessionQueryToken} from 'src/fund/api/useRetrieveFundingSessionQuery';
import type {
  ValidateAllPermissions,
  FunctionParameterToken,
  ValidatePermissions,
} from '@sail/data';

export const useRetrieveFundingSession = (
  fundingSessionId: string,
  token: RetrieveFundingSessionQueryToken,
) => {
  const {data, ...queryState} = useRetrieveFundingSessionQuery({
    variables: {v2Context: {}, fndsess: fundingSessionId},
    // data-v2 authenticates with the session-scoped UAT carried by this token.
    token,
    component: 'useRetrieveFundingSession',
  });

  return {data, ...queryState};
};

// THIS IS AUTOGENERATED CODE FOR PERMISSION TOKEN, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY

// prettier-ignore
export type validate = ValidateAllPermissions<
  ValidatePermissions<RetrieveFundingSessionQueryToken, [
    FunctionParameterToken<typeof useRetrieveFundingSessionQuery>
  ]>
>;
